 import React from 'react';
 import "./Timeline.css";
import Sidebar from '../../Component/sidebar/sidebar';
import Header from '../../Component/header/Header';
import Users from '../../Component/sub-timeline/users';


function Timeline() {
  return (
    <div className="container">
      <div className="row row-cols-2">
        {/* SIDEBAR DESIGN */}
        <div className="col-2 sidebar">
            <Sidebar />
        </div>

        {/* CONTENT DESIGN */}
        <div className="col-10 content">
          <Header title={"Timeline"}/>
          {/* users section */}
          <Users />
        </div>
      </div>
    </div>
  )
}

export default Timeline;